import { useEffect, useState } from "react";
import { getApi, postApi } from "../../ApiServices/api";
import { apiEndPoints } from "../../ApiServices/config";
import moment from "moment";
import { useSearchParams } from "react-router-dom";

function useLoadMasterDataHome() {
  const [gallery, setGallery] = useState();
  const [masterData, setMasterData] = useState({
    slider: null,
    monthlyNewsletter: null,
    annualCalendar: null,
    latestNews: null,
    spotlight: null,
    services: null,
    liveStreamingUrlData: null,
    dailyPanchangam: null,
    dailyNews: null,
    allEvents: null,
    upcomingEvents: null,
    templeMission: null,
  });

  const getMasterData = async () => {
    const date = moment().tz("America/New_York").format("ddd, DD MMM YYYY ");
    const payload = {
      date,
    };
    const newsPayload = {
      limits: 5,
    };
    const result = await Promise.all([
      getApi(apiEndPoints.getHomePageSliderItems),
      getApi(apiEndPoints.getMonthlyNewsletter),
      getApi(apiEndPoints.getAnnualCalender),
      getApi(apiEndPoints.getHomePageScrollerItems),
      getApi(apiEndPoints.getHomePageSpotlightItems),
      getApi(apiEndPoints.getHomePageServiceCatogryItems),
      getApi(apiEndPoints.getliveStreamingUrl),
      postApi(apiEndPoints.getHomePagePanchang, payload),
      postApi(apiEndPoints.getHomePageLatesNewsItems, newsPayload),
      getApi(apiEndPoints.getHomePageLatesEventItems),
      postApi(apiEndPoints.getHomePageUpcomingEvents),
      getApi(apiEndPoints.getHomePageTempleMissionItems),
    ]);

    setMasterData({
      slider: result[0]?.data,
      monthlyNewsletter: result[1]?.data,
      annualCalendar: result[2]?.data,
      latestNews: result[3]?.data,
      spotlight: result[4]?.data,
      services: result[5]?.data?.data,
      liveStreamingUrlData: result[6]?.data?.data,
      dailyPanchangam: result[7]?.data?.data,
      dailyNews: result[8]?.data?.data,
      allEvents: result[9]?.data?.data,
      upcomingEvents: result[10]?.data,
      templeMission: result[11]?.data,
    });

    const [galleryList, galleryCategories, galleryFestivals, galleryTags] =
      await Promise.all([
        postApi(apiEndPoints.allGallery, payload),
        getApi(apiEndPoints.galleryCategories),
        getApi(apiEndPoints.galleryFestivals),
        getApi(apiEndPoints.galleryTags),
      ]);

    setGallery({
      list: galleryList?.data?.status == 1 ? galleryList?.data?.data : [],
      categories:
        galleryCategories?.data?.status == 1
          ? galleryCategories?.data?.data
          : [],
      festival:
        galleryFestivals?.data?.status == 1 ? galleryFestivals?.data?.data : [],
      tags: galleryTags?.data?.status == 1 ? galleryTags?.data?.data : [],
    });
  };

  const [todaySchedule, setTodaySchedule] = useState([]);
  const [tab, setTab] = useState("Monthly");
  const [date, setDate] = useState(
    moment().tz("America/New_York").format("YYYY-MM-DD")
  );

  function formatDateForDisplay(date) {
    return moment(date).tz("America/New_York").format("ddd, DD MMM YYYY");
  }
  const updateDate = (days) => {
    const newDate = moment(date).add(days, "days").format("YYYY-MM-DD");
    setDate(newDate);
  };

  const payload = {
    date: date,
  };

  const getSchedule = async () => {
    try {
      const response = await postApi(
        apiEndPoints.getHomePagetodaysPujaSchedule,
        payload
      );
      setTodaySchedule(response?.data?.data);
    } catch (error) {
      console.log(error);
    }
  };

  const handleChange = (event, newValue) => {
    setTab(newValue);
  };

  useEffect(() => {
    getSchedule();
  }, [date]);

  return {
    todaySchedule,
    handleChange,
    updateDate,
    formatDateForDisplay,
    tab,
    date,
    masterData,
    getMasterData,
    gallery,
    setMasterData,
  };
}

export const useSlider = () => {
  const [sliderData, setSliderData] = useState(null);

  const fetchSliderData = async () => {
    const response = await getApi(apiEndPoints.getHomePageSliderItems);
    setSliderData(response?.data);
  };

  return { sliderData, fetchSliderData };
};

export const useLatestUpdatesMasterhook = () => {
  const [masterData, setMasterData] = useState({
    monthlyNewsletter: null,
    annualCalendar: null,
    latestNews: null,

  });

  const fetchMasterData = async () => {
    const result = await Promise.all([
      getApi(apiEndPoints.getMonthlyNewsletter),
      getApi(apiEndPoints.getAnnualCalender),
      getApi(apiEndPoints.getHomePageScrollerItems),
      getApi(apiEndPoints.getScrollerConfigs),
    ]);

    setMasterData({
      monthlyNewsletter: result[0]?.data,
      annualCalendar: result[1]?.data,
      latestNews: result[2]?.data,
      scrollerConfigs: result[3]?.data?.data,
    });
  };

  return { masterData, fetchMasterData };
};

export const useDailyScheduleMasterHook = () => {
  const [todaySchedule, setTodaySchedule] = useState([]);
  const [date, setDate] = useState(
    moment().tz("America/New_York").format("YYYY-MM-DD")
  );

  const updateDate = (days) => {
    const newDate = moment(date).add(days, "days").format("YYYY-MM-DD");
    setDate(newDate);
  };

  function formatDateForDisplay(date) {
    return moment(date).tz("America/New_York").format("dddd, MMM DD YYYY");
  }

  const fetchSchedule = async () => {
    const payload = {
      date: date,
    };

    const response = await postApi(
      apiEndPoints.getHomePagetodaysPujaSchedule,
      payload
    );
    setTodaySchedule(response?.data?.data);
  };

  return {
    todaySchedule,
    setTodaySchedule,
    date,
    updateDate,
    fetchSchedule,
    formatDateForDisplay,
  };
};

export const useUpcomingEventsMasterHook = () => {
  const [events, setEvents] = useState();
  const [tab, setTab] = useState("Monthly");

  const fetchEvents = async () => {
    const upcomingEvents = await postApi(
      apiEndPoints.getHomePageUpcomingEvents
    );

    setEvents(upcomingEvents?.data);
  };
  const handleChange = (event, newValue) => {
    setTab(newValue);
  };
  return { events, fetchEvents, handleChange, tab };
};

export const useNewsMasterHook = () => {
  const [news, setNews] = useState();

  const fetchNews = async () => {
    const newsPayload = {
      limits: 5,
    };
    const result = await postApi(
      apiEndPoints.getHomePageLatesNewsItems,
      newsPayload
    );
    setNews(result?.data?.data);
  };

  return { news, fetchNews };
};

export const useEventsMasterHook = () => {
  const [events, setEvents] = useState();

  const fetchEvents = async () => {
    const result = await getApi(apiEndPoints.getHomePageLatesEventItems);
    setEvents(result?.data?.data);
  };

  return { events, fetchEvents };
};

export const useServices = () => {
  const [services, setServices] = useState(null);

  const fetchServices = async () => {
    const response = await getApi(apiEndPoints.getHomePageServiceCatogryItems);
    setServices(response?.data?.data);
  };

  return { services, fetchServices };
};

export const usePanchangam = () => {
  const [panchangam, setPanchangam] = useState(null);

  const fetchPanchangam = async (date) => {
    const response = await postApi(apiEndPoints.getHomePagePanchang, { date });
    setPanchangam(response?.data?.data);
  };

  return { panchangam, fetchPanchangam };
};

export const useLiveStreaming = () => {
  const [streamingUrl, setStreamingUrl] = useState(null);

  const fetchStreamingUrl = async () => {
    const response = await getApi(apiEndPoints.getliveStreamingUrl);
    setStreamingUrl(response?.data?.data[0]);
  };

  return { streamingUrl, fetchStreamingUrl };
};

export const useNewsletter = () => {
  const [newsletter, setNewsletter] = useState({
    monthly: null,
    annual: null,
  });

  const fetchNewsletter = async () => {
    const [monthly, annual] = await Promise.all([
      getApi(apiEndPoints.getMonthlyNewsletter),
      getApi(apiEndPoints.getAnnualCalender),
    ]);

    setNewsletter({
      monthly: monthly?.data,
      annual: annual?.data,
    });
  };

  return { newsletter, fetchNewsletter };
};

export default useLoadMasterDataHome;

export const useNewsData = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [page, setPage] = useState(parseInt(searchParams.get("page") || 1));
  const [news, setNews] = useState([]);
  const [dailyNews, setDailyNews] = useState([]);
  const [count, setCount] = useState(0);

  const handleChange = (event, value) => {
    setPage(value);
    setSearchParams({ page: value });
    window.scrollTo(0, 0);
  };

  const getNews = async () => {
    try {
      const response = await postApi(apiEndPoints.getallNews, { page });
      if (response?.status === 200) {
        setNews(response.data.data);
        setCount(response.data.total_pages);
      }
    } catch (err) {
      console.error("Error fetching news:", err);
    }
  };

  const getLatestNews = async () => {
    try {
      const response = await postApi(apiEndPoints.news, { limits: 5 });
      if (response?.status === 200) {
        setDailyNews(response.data.data);
      }
    } catch (err) {
      console.error("Error fetching latest news:", err);
    }
  };

  useEffect(() => {
    getNews();
    getLatestNews();
  }, [page]);

  return {
    page,
    news,
    count,
    dailyNews,
    handleChange,
  };
};

export const useEventsData = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [page, setPage] = useState(Number(searchParams.get("page")) || 1);
  const [events, setEvents] = useState([]);
  const [latestEvents, setLatestEvents] = useState([]);
  const [totalPages, setTotalPages] = useState(0);

  const handlePageChange = (event, value) => {
    setPage(value);
    setSearchParams({ page: value });
    window.scrollTo(0, 0);
  };

  useEffect(() => {
    const fetchEvents = async () => {
      const response = await postApi(apiEndPoints.getAllPaginatedEvents, {
        page,
      });
      if (response?.status === 200) {
        setEvents(response.data.data);
        setTotalPages(response.data.total_pages);
      }
    };

    const fetchLatestEvents = async () => {
      const response = await getApi(apiEndPoints.allHomePageEvents);
      if (response?.status === 200) {
        setLatestEvents(response.data.data);
      }
    };

    fetchEvents();
    fetchLatestEvents();
  }, [page]);

  return {
    events,
    latestEvents,
    totalPages,
    page,
    handlePageChange,
  };
};
